import '@apollo/client'
import {
  ApolloQueryResult,
  OperationVariables,
  useMutation
} from '@apollo/client'
import { IconButton, Typography } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { ConfirmActionModal } from '../../components/ConfirmActionModal'
import { DELETE_WEBHOOK_MUTATIONS } from '../../graphql/channelPush'
import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../helpers/date'
import { getTranslate, lang } from '../../localization'
import { PushDetails, WebHook } from '../../types/channelPush'
import useStyles from './styles/adaptorsTableRow.styles'

interface AdaptorsTableRowProps {
  data: WebHook
  onClick: () => void
  getWebHookLabelByValue: (value: string) => string | undefined
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      channelPush: PushDetails
    }>
  >
}

export const AdaptorsTableRow: React.FC<AdaptorsTableRowProps> = ({
  data,
  onClick,
  getWebHookLabelByValue,
  refetch
}) => {
  const classes = useStyles()
  const { channelCode } = useParams<{ channelCode: string }>()
  const { adaptor, interval, state, lastAttempt, failureCount, endPoint } = data
  const [deleteModalIsOpen, setdeleteModalIsIpen] = useState<boolean>(false)
  const [deleteNewWebHook] = useMutation(DELETE_WEBHOOK_MUTATIONS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: (response) => {
      refetch()
      toast.success(response.deleteWebHook.message)
    },
    onError: (error) => {
      toast.error(error.message)
    }
  })

  return (
    <div className={classes.tableRow}>
      <div onClick={onClick} className={classes.tableRowExceptMenuItem}>
        <div>
          <Typography variant="h4">
            {getWebHookLabelByValue(adaptor)}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">{interval}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate(state)}</Typography>
        </div>
        <div>
          <Typography variant="body1">
            {lang == 'fa'
              ? gregorianToJalaaliWithHourMinuteAndSecond(lastAttempt)
              : lastAttempt}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">{failureCount}</Typography>
        </div>
        <div className={classes.endpointcontainer}>
          <Typography variant="body1">{endPoint}</Typography>
        </div>
      </div>
      <div className={classes.menuIcon}>
        <IconButton
          onClick={(event) => {
            event.nativeEvent.stopImmediatePropagation()
            event.preventDefault()
            setdeleteModalIsIpen(true)
          }}>
          <DeleteIcon />
        </IconButton>
        {deleteModalIsOpen && (
          <ConfirmActionModal
            icon={<DeleteIcon className={classes.icon} />}
            title={adaptor + ' ' + getTranslate(' is about to deleted ')}
            subtitle={'Are you sure you want to delete it permanently?'}
            signature={'Delete Me'}
            onClose={() => setdeleteModalIsIpen(false)}
            isOpen={deleteModalIsOpen}
            onClick={() => {
              setdeleteModalIsIpen(false)
              deleteNewWebHook({
                variables: {
                  input: {
                    channelCode: channelCode,
                    adaptor: adaptor
                  }
                }
              })
            }}
            loading={false}
          />
        )}
      </div>
    </div>
  )
}
